import React from "react";
type buttonprops={
    className:string;
    bname:string;
    name:string;
    id:string;
    [key: string]: any    
}
const Button = ({className,name,bname,id,...attr}:buttonprops) =>{
    return(
        <button id={id} name={name} className={className} {...attr} >
          {bname}
        </button>
    )
}
export {Button}